export default __webpack_public_path__ + "static/media/springboot.9781f480.svg";